<div class="valueBreakdownFieldPicker">
  <div class="valueBreakdownFieldPicker__wrapper">
    <pp-new-dashlet-modal-value-breakdown-fields-custom-field-picker-select
      [ppFieldType]="'list'"
      [ppFieldId]="ppListFieldId()"
      (ppFieldIdChange)="ppListFieldIdChange.emit($event)"
      [ppWorkspaceId]="ppWorkspaceId()"
    ></pp-new-dashlet-modal-value-breakdown-fields-custom-field-picker-select>

    <div class="valueBreakdownFieldPicker__arrows">
      <pp-icon
        [ppSrc]="EIconPath.ICON_COMPARE_ARROWS"
        ppClass="setSize14"
        ppColor="grey-400"
      ></pp-icon>
    </div>

    <pp-new-dashlet-modal-value-breakdown-fields-custom-field-picker-select
      [ppFieldType]="'numerical'"
      [ppFieldId]="ppNumericalFieldId()"
      (ppFieldIdChange)="ppNumericalFieldIdChange.emit($event)"
      [ppWorkspaceId]="ppWorkspaceId()"
    ></pp-new-dashlet-modal-value-breakdown-fields-custom-field-picker-select>
  </div>
</div>
